import { createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "canvas",
  class: "pantry-camera-check-image-view-canvas"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _mergeProps({ class: "pantry-camera-check-image-view" }, _ctx.drawScreen), [
    _createVNode("canvas", _hoisted_1, null, 512)
  ], 16))
}